import { useRouteMatch } from 'react-router';

export default function useUserIdFromRoute() {
  const {
    params: { userId },
  } = useRouteMatch<{ userId?: string }>();
  // try to convert userId to number
  const num = Number(userId);
  // subpath when userId is not set will be converted to NaN
  const id = isNaN(num) ? undefined : num;
  return id;
}
